import { render, staticRenderFns } from "./gdConfigInfos.vue?vue&type=template&id=3e7bd26a&scoped=true&"
import script from "./gdConfigInfos.vue?vue&type=script&lang=js&"
export * from "./gdConfigInfos.vue?vue&type=script&lang=js&"
import style0 from "./gdConfigInfos.vue?vue&type=style&index=0&id=3e7bd26a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7bd26a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e7bd26a')) {
      api.createRecord('3e7bd26a', component.options)
    } else {
      api.reload('3e7bd26a', component.options)
    }
    module.hot.accept("./gdConfigInfos.vue?vue&type=template&id=3e7bd26a&scoped=true&", function () {
      api.rerender('3e7bd26a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/banquet_management/banquet_gd_details/form/components/gdConfigInfos.vue"
export default component.exports